'use client'

import { SessionProvider } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { AIManager } from '@/components/ai/AIManager'
import { SignedInAssistantPersonaProvider } from '@/context/AssistantPersonaContext'
import { BriefingProvider } from '@/context/BriefingContext'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      // Refetch session every 4 minutes to keep tokens fresh
      // This triggers the JWT callback which handles token refresh
      refetchInterval={4 * 60}
      // Also refetch when user returns to the tab
      refetchOnWindowFocus={true}
    >
      {/* Plan 03 CHG-05: one AI Employee name for the header pill, chat panel and pages. */}
      <SignedInAssistantPersonaProvider>
        {/* Plan 03 CHG-13: one briefing poll for the hero, the header bell and the chips. */}
        <BriefingProvider>
          <AIProvider>
            {children}
            <ToastProvider />
            <CommandPalette />
            <AIManager />
          </AIProvider>
        </BriefingProvider>
      </SignedInAssistantPersonaProvider>
    </SessionProvider>
  )
}
